import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './Section';
import { CountdownDisplay } from './Countdown';
export function UrgencySection() {
  return <Section className="gradient-urgency py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden border-y border-[rgba(232,197,245,0.2)]" data-id="element-277">
      <div className="absolute inset-0 bg-bgLight/5 animate-pulse-slow" data-id="element-278"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-279">
        <div className="inline-flex items-center gap-2 bg-dangerSoft/10 text-dangerSoft border border-dangerSoft/20 px-4 py-1.5 rounded-full text-sm font-bold mb-8" data-id="element-280">
          <span data-id="element-281">⏰</span> PRECIO DE LANZAMIENTO — CIERRA EN:
        </div>

        <div className="mb-8" data-id="element-282">
          <CountdownDisplay data-id="element-283" />
        </div>

        <p className="text-bodyOnDark text-lg mb-8 flex items-center justify-center gap-2" data-id="element-284">
          <span data-id="element-285">⚠️</span> Después sube $8.000 ARS. No vuelve.
        </p>

        <div className="bg-[rgba(45,27,78,0.4)] border border-[rgba(232,197,245,0.2)] rounded-xl p-6 max-w-md mx-auto" data-id="element-286">
          <div className="flex justify-between text-sm mb-2" data-id="element-287">
            <span className="text-headlineLight flex items-center gap-2" data-id="element-288">
              <span className="w-2 h-2 rounded-full bg-moonGlow animate-pulse" data-id="element-289"></span>
              Cupos al precio de lanzamiento
            </span>
          </div>
          <div className="w-full bg-[rgba(255,255,255,0.1)] rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-290">
            <motion.div initial={{
            width: 0
          }} whileInView={{
            width: '68%'
          }} transition={{
            duration: 1.5,
            ease: 'easeOut'
          }} className="bg-gradient-to-r from-ctaFrom to-moonGlow h-2.5 rounded-full" data-id="element-291"></motion.div>
          </div>
          <p className="text-xs text-accentText text-right" data-id="element-292">
            68% de los cupos ya tomados — Quedan pocos
          </p>
        </div>
      </div>
    </Section>;
}